<template>
  <div>
    <el-dropdown placement="bottom-start">
      <el-button type="primary" :loading="uploadLoading">
        <template v-if="isComplaint">导入投诉</template>
        <template v-else>导入项目</template>
      </el-button>
      <template slot="dropdown">
        <el-dropdown-menu>
          <el-dropdown-item>
            <el-button size="small" v-if="isComplaint" type="warning" icon="el-icon-download" @click="handleDownloadTemplateException">下载导入模板</el-button>
            <el-button size="small" v-else type="warning" icon="el-icon-download" @click="handleDownloadTemplateProject">下载导入模板</el-button>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-upload
                action="#"
                :file-list="fileList"
                class="upload-demo"
                :multiple="false"
                :limit="1"
                :before-upload="handleBeforeUpload"
                :http-request="handleCustomUpload"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :show-file-list="false"
            >
              <el-button size="small" type="success" icon="el-icon-upload2">选择导入文件</el-button>
            </el-upload>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <myModal ref="myModalRef" title="提示" width="600px" :verticalCenter="true">
      <div v-html="successText"></div>
      <template slot="footer">
        <el-button @click="handleCloseMyModal">关闭</el-button>
      </template>
    </myModal>
</div>
</template>

<script>
import {defineComponent} from 'vue'
import {downloadTemplateinfo} from "@/api/upload/upload";
import { getToken } from "@/utils/token";
import myModal from "../MyModal/index.vue";
import { importProject, importComplaint } from "@/api/unpaidWages/complaint/index";

export default defineComponent({
  name: "index",
  components: {
    myModal
  },
  props: {
    type: {
      type: String,
      default: 'exception'
    }
  },
  data(){
    return {
      uploadLoading: false,
      fileList: [],
      successText: ""
    }
  },
  computed: {
    isComplaint() {
      return this.type === "exception";
    },
    isProject() {
      return this.type === "project";
    },
  },
  methods: {
    getToken,
    handleDownloadTemplateException() {
      console.log('下载投诉模板')
      return this.downloadTemplate('/backpayComplaintInfo/gl/v1.0.0/excelTemplateGain');
    },
    handleDownloadTemplateProject() {
      console.log('下载项目模板')
      return this.downloadTemplate('/backpayProjectInfo/gl/v1.0.0/excelTemplateGain');
    },
    handleBeforeUpload() {
      console.log('开始上传');
      this.uploadLoading = true;
    },
    async handleCustomUpload({ file, onSuccess, onError }) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        const api = this.isComplaint ? importComplaint : importProject;
        const res = await api(formData);
        onSuccess(res);
      } catch (err) {
        onError(err);
      }
    },
    handleUploadSuccess(res) {
      try {
        if(res.code === 200) {
          console.log("上传成功", res, this.$refs);
          this.successText = res.data;
          this.$emit("handleUpdateData");
          this.$refs.myModalRef && this.$refs.myModalRef.handleOpen();
        }else{
          console.log("上传失败")
          this.successText = res.msg || "上传失败！";
          this.$refs.myModalRef && this.$refs.myModalRef.handleOpen();
        }
      } finally {
        this.uploadLoading = false;
        this.fileList.length = 0;
      }
    },
    handleCloseMyModal() {
      this.$refs.myModalRef && this.$refs.myModalRef.handleDirectlyClose();
    },
    handleUploadError() {
      try {
        console.log("上传失败")
        this.successText = "上传失败！";
        this.$refs.myModalRef && this.$refs.myModalRef.handleOpen();
      } finally {
        this.uploadLoading = false;
        this.fileList.length = 0;
      }
    },
    async downloadTemplate(url) {
      this.uploadLoading = true;
      try {
        const response = await downloadTemplateinfo(url);
        console.log('响应数据:', response);
        
        // 确保response是Blob
        let blob;
        if (response instanceof Blob) {
          blob = response;
        } else if (response.data instanceof Blob) {
          blob = response.data;
        } else {
          // 如果不是Blob，尝试转换
          blob = new Blob([response], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
        }
        
        // 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        // 生成文件名（可以根据时间或从URL提取）
        const timestamp = new Date().getTime();
        link.download = `template_${timestamp}.xls`;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // 清理
        setTimeout(() => {
          window.URL.revokeObjectURL(downloadUrl);
        }, 100);
        
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('下载失败');
      } finally {
        this.uploadLoading = false;
      }
    },
    // 从响应头解析文件名的辅助函数
    getFileNameFromHeaders(headers) {
      const contentDisposition = headers['content-disposition'];
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (fileNameMatch.length > 1) {
          return fileNameMatch[1];
        }
      }
      return null;
    }
  }
})
</script>

<style scoped lang="scss">

</style>